"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHammer, faXmark } from "@instadeepai/fontawesome-pro-regular"

import { Button, Card, DialogClose, IconButton } from "@shared/ui"

import { Module } from "../types"

interface ModuleDetailsProps {
  module: Module
  onForgeClick: () => void
  isConfigOpen?: boolean
  showCloseButton?: boolean
  className?: string
}

export const ModuleDetails = ({
  module,
  onForgeClick,
  isConfigOpen = false,
  showCloseButton = false,
}: ModuleDetailsProps) => {
  return (
    <Card className="flex h-full flex-col border-gray-100 bg-gray-50 px-4 py-6">
      <div className="mb-6 flex flex-col items-center justify-between gap-4 lg:flex-row">
        <div className="flex items-center gap-4">
          {showCloseButton && (
            <DialogClose asChild>
              <IconButton
                aria-label="Close"
                variant="secondaryRound"
                className="px-5 py-2"
                icon={<FontAwesomeIcon icon={faXmark} />}
              />
            </DialogClose>
          )}
          <h2 className="text-xl font-semibold text-gray-900">
            {showCloseButton ? `${module.title} Module` : "Module Details"}
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <Button
            onClick={onForgeClick}
            variant={isConfigOpen ? "tertiary" : "primary"}
            disabled={isConfigOpen}
            rightIcon={<FontAwesomeIcon icon={faHammer} />}
          >
            Forge with Module
          </Button>
        </div>
      </div>
      <div className="space-y-2 overflow-auto px-2">
        {[...Array(5)].map((_, i) => (
          <p
            key={i}
            className="rounded-md border border-gray-100 p-4 text-gray-500"
          >
            Lorem ipsum dolor sit amet consectetur. Integer leo ante integer
            hendrerit sit nulla nisl faucibus. Mattis dictum lectus vestibulum
            purus mattis. Imperdiet vel lobortis elementum vestibulum lorem
            accumsan. Fermentum a congue malesuada sit viverra at ante blandit.
            Sem ultrices et lacus tincidunt in diam consectetur. Non nulla eu
            luctus arcu volutpat. Bibendum viverra vulputate nullam amet.
          </p>
        ))}
      </div>
    </Card>
  )
}
